module.exports = __webpack_public_path__ + "static/media/RockandCode_cover.97f5a7d1.png";